import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { HttpModule } from '@angular/http';
import 'rxjs/add/operator/map';
import { tokenNotExpired } from 'angular2-jwt';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
@Injectable()
export class AuthService {
  authToken: any;
  user: any;
  // baseURL = 'http://localhost:8080/';
  baseURL = 'http://localhost:5002/';
  loggedIn$ = new BehaviorSubject(null);

  // baseURL = '';
  constructor(private http: HttpClient) {
    if (window.location.href.includes('localhost')) {
      this.baseURL = 'http://localhost:5002/';
      console.log('Setting base URL for Angular  : ' + this.baseURL);
    } else {
      this.baseURL = '';
      console.log(
        'Setting base URL for Angular  : ' + this.baseURL + window.location.href
      );
    }
    // this.isDev = true;  // Change to false before deployment
  }

  get isLoggedIn() {
    return this.loggedIn$.getValue();
  }

  registerUser(user) {
    return this.http.post(this.baseURL + 'busers/register', user);
  }

  registerPhoneNo(user) {
    return this.http.post(this.baseURL + 'busers/registerPhoneNo', user);
  }

  verifyPhoneNo(user) {
    return this.http.post(this.baseURL + 'busers/verifyPhoneNo', user);
  }

  authenticateUser(user) {
    return this.http.post(this.baseURL + 'busers/authenticate', user).pipe(
      tap((response: any) => {
        this.loggedIn$.next(true);
        this.user = response.user;
      })
    );
  }

  getProfile() {
    return this.http.get(this.baseURL + 'busers/profile').pipe(
      tap((response: any) => {
        this.loggedIn$.next(true);
        this.user = response.user;
      })
    );
  }

  updateProfile(obj) {
    return this.http.post(this.baseURL + 'busers/updateProfile', obj);
  }

  updatePassword(password) {
    return this.http.put(this.baseURL + `busers/updatePassword`, password);
  }

  editProfile(obj) {
    return this.http.patch(this.baseURL + 'busers/editProfile', obj);
  }

  storeUserData(token, user) {
    localStorage.setItem('bUser_token', token);
    localStorage.setItem('user', JSON.stringify(user));
    this.authToken = token;
    this.user = user;
  }

  loadToken() {
    const token = localStorage.getItem('bUser_token');
    this.authToken = token;
    const user = localStorage.getItem('user');
    this.user = user;
  }

  loggedIn() {
    return tokenNotExpired('bUser_token');
  }

  logout() {
    return this.http.post(this.baseURL + 'busers/logout', {});
  }
}
